import { FilteredCreditApplication } from '@applyonline/shared'
import { scrollToTop } from '@applyonline/shared/utils'
import { EApplicantType, EDocumentType, ERequiredFrom } from '@if/core/types'
import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  areAllDocumentsRequiredFromClientApproved,
  hasApplicantStartedFlinksAnalysis,
  hasMissingDocuments,
} from '../../../../../data/credit-application-selectors'
import CreditStep, { CreditStepStatus } from './CreditStep'

interface DocumentsCreditStepProps {
  creditApp: FilteredCreditApplication
}
const DocumentsCreditStep = ({ creditApp }: DocumentsCreditStepProps) => {
  const { t } = useTranslation()
  const allDocsAreApproved = areAllDocumentsRequiredFromClientApproved(creditApp)
  const isMissingClientDocs = hasMissingDocuments(creditApp, undefined, ERequiredFrom.Customer)
  const serviceProviderMustSendDocs = hasMissingDocuments(creditApp, undefined, ERequiredFrom.ServiceProvider)
  const allDocUploadAndWaitingForFlinks =
    !hasMissingDocuments(creditApp, undefined, ERequiredFrom.Customer, [EDocumentType.VoidCheque]) &&
    hasApplicantStartedFlinksAnalysis(creditApp, EApplicantType.Applicant)
  const status: CreditStepStatus = isMissingClientDocs ? CreditStepStatus.RequiresAttention : CreditStepStatus.Completed
  let desc

  if (allDocUploadAndWaitingForFlinks) desc = 'overview.waitingFlinks' as const
  else if (isMissingClientDocs) desc = 'overview.moreDocs' as const
  else if (serviceProviderMustSendDocs && !isMissingClientDocs) desc = 'overview.serviceProviderMustSendDocs' as const
  else if (allDocsAreApproved) desc = 'overview.noDocuments' as const
  else desc = 'overview.documentReview' as const
  useLayoutEffect(scrollToTop, [])

  return (
    <CreditStep
      status={status}
      linkToDetail="required-documents"
      hideLinkToDetail={allDocsAreApproved}
      title={t('overview.documentsStep')}
      content={t(desc)}
      noConnector
    />
  )
}

export default DocumentsCreditStep
